module.exports = __webpack_public_path__ + "img/mobile.41a47f25.png";